import EditChildModal from './EditChildModal';
import withPromise from '../../components/withPromise';
import api from '../../api';

export default withPromise(api.children.update)(EditChildModal);
